import store from "@/store";
import { ElMessage, ElMessageBox } from "element-plus";
import CryptoJS from "crypto-js";
import { pageSize } from "./base";
import { Decimal } from "decimal.js";

//获取光标选中内容
export const onFocus = (item) => {
  if (item?.target) item?.target.select();
};

//生成表格序号
export const buildTabIndex = (page, limit, index) => {
  if (limit === undefined || limit === null) limit = pageSize;

  return (page - 1) * limit + index + 1;
};

//权限验证
export const judge_auth = (qxs) => {
  if (Array.isArray(qxs)) {
    return (
      store.state.loginUser?.is_super_auth == 1 ||
      store.state.loginUser?.codes?.some((w) => qxs.includes(w))
    );
  } else {
    return (
      store.state.loginUser?.is_super_auth == 1 ||
      store.state.loginUser?.codes?.includes(qxs)
    );
  }
};

//一键复制
export const onCopy = (value) => {
  if (value == null || value == undefined) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard 向剪贴板写文本
      navigator.clipboard.writeText(value);
    } else {
      // 创建text area
      let textArea = document.createElement("textarea");
      textArea.value = value;
      // 使text area不在viewport，同时设置不可见
      textArea.style.position = "absolute";
      textArea.style.opacity = 0;
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
    }
    ElMessage({
      type: "success",
      message: "已复制",
      grouping: true,
    });
  } catch (err) {
    ElMessage({
      type: "error",
      message: "复制失败",
      grouping: true,
    });
  }
};

/* 带提示框的通用请求接口函数
 * func：请求接口
 * id：数据Id
 * backFunc：回调
 * message：提示语
 */
export const onDeleteConfirm = (func, id, backFunc, item) => {
  let message =
    "您确定<strong style='color:var(--el-color-danger)'>删除</strong>吗？";

  if (item.filed) {
    message = `您确定<strong style='color:var(--el-color-danger)'>删除${item.filed}</strong><strong style='font-weight:bold;color:#000'>${item.name}</strong>吗?`;
  }

  ElMessageBox.confirm(message, "删除确认", {
    confirmButtonText: "立即删除",
    cancelButtonText: "取消",
    dangerouslyUseHTMLString: true,
    type: "error",
    customClass: "c-delete-dialog",
    confirmButtonClass: "el-button--danger",
    cancelButtonClass: "is-plain",
  }).then(() => {
    func(id).then((res) => {
      if (res.status == 200) {
        ElMessageBox.alert(res.data?.msg, "提示", {
          dangerouslyUseHTMLString: true,
          type: "success",
          callback: () => {
            backFunc();
          },
        });
      } else {
        ElMessage({
          message: res.data,
          type: "error",
        });
      }
    });
  });
};

//提交接口处理函数
export const post_response = (res, backFunc) => {
  if (res.status == 200) {
    ElMessage({
      message: res.data?.msg,
      showClose: true,
      grouping: true,
      dangerouslyUseHTMLString: true,
      type: "success",
    });
    backFunc();
  }
};

//加密
export const encrypt = (plainText) => {
  let keyBytes = CryptoJS.enc.Utf8.parse("bfad1a27d2438940ed995fc54827c35a");
  let ivBytes = CryptoJS.enc.Utf8.parse("bfad1a27d2438940");
  let encrypted = CryptoJS.AES.encrypt(plainText, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC, // 设置加密模式为CBC
    padding: CryptoJS.pad.Pkcs7, // 设置填充模式为PKCS7
  });
  return encrypted.toString();
};

//数字转换成decimal格式，空值返回0
export const toDecimal = (value) => {
  // 空、undefined、null、纯空白字符串 → 返回 0
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    /^\s*$/.test(value)
  ) {
    return new Decimal(0);
  }

  // 否则正常创建（用字符串保证精度）
  return new Decimal(String(value));
};

//格式化数字：小数部分全0则只输出整数，否则保留有效小数
export const formatDecimal = (num) => {
  const d = toDecimal(num);
  // 判断是否整数（小数部分为0）
  if (d.isInteger()) {
    return d.toFixed(0);
  }
  // 去除末尾多余0，不补位
  return d.toFixed().replace(/\.?0*$/, "");
};

//有小数则保留，最多支持2位小数
export const formatMaxTwoDecimals = (num) => {
  // 保留最多2位小数，四舍五入（ROUND_HALF_UP 是标准四舍五入）
  const result = toDecimal(num).toNumber().toFixed(2, Decimal.ROUND_HALF_UP);
  // 关键：去除末尾无用的 0 和小数点（10.00 → 10，10.50 → 10.5）
  return result.replace(/\.0+$/, "").replace(/(\.\d)0$/, "$1");
};

//多选下拉框选择项溢出文本框则开启折叠
export const onSelectCollapse = (
  selectDom,
  config = {
    status: false,
    max: 2,
  },
  value,
) => {
  return new Promise((resolve) => {
    if (selectDom == null) return resolve(config);

    setTimeout(() => {
      // 输入框外层容器可视宽度
      const wrapWidth = selectDom.value.$el.clientWidth;
      // 标签容器真实内容宽度
      const tagsEl = selectDom.value.$el.querySelector(".el-select__selection");
      if (!tagsEl) return;
      const contentWidth = tagsEl.scrollWidth;

      if (!config.status) {
        //若已开启折叠
        // 差值阈值预留一点边距（20）防止临界反复切换
        config.status = contentWidth > wrapWidth - 20;
        if (config.status) {
          if (config.max == 2) {
            config.max = value.length - 1;
          }
        }
      }
      resolve(config);
    }, 50);
  });
};

//导出Excel
export const funcExport = (func, data) => {
  func(data)
    .then((res) => {
      let fileName = decodeURI(
        res.headers["content-disposition"].split("=")[1],
      );

      //通过后台返回 的word文件流设置文件名并下载
      var blob = new Blob([res.data], {
        type: res.data.type,
      });
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    })
    .catch((err) => {
      const fileReader = new FileReader();
      fileReader.readAsText(
        new Blob([err.data], { type: "application/octet-stream" }),
        "utf-8",
      );
      fileReader.onload = () => {
        const msg = JSON.parse(fileReader.result);
        ElMessage.error(msg?.msg);
      };
    });
};